(ns minorodata.connections.sources.elasticsearch
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as str]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as tools]
            [mold-forms.core :as form-component]))


(spec/def ::name
  (spec/and (tools/spec string? {:reason "Please provide a name for the source"})
            (tools/spec (complement str/blank?) {:reason "Name can't be empty"})))


(spec/def ::description (spec/nilable string?))


(spec/def ::elasticsearch-url
  (spec/and (tools/spec string? {:reason "Please provide a url (eg: https://example.com:9243)"})
            (tools/spec (complement str/blank?) {:reason "Elasticsearch url can't be empty"})))


(spec/def ::elasticsearch-form
  (spec/and (spec/keys :req-un [::name ::elasticsearch-url]
                       :opt-un [::description ::user ::password])))


(def source
  {:id           "elasticsearch"
   :enabled      true
   :name         "Elasticsearch"
   :description  "World’s leading free and open search and analytics solution."
   :image-source "elasticsearch.png"
   :tags         ["data-import"]

   :preview-formatter (fn [] "")

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [elasticsearch-url name description user password
                    bastion-hostname bastion-user bastion-port private-key has-bastion?]} data]
        {:source-type "elasticsearch"
         :name        name
         :description description

         :source
         (cond-> {:credentials       {:type     "basic_authentication"
                                      :user     user
                                      :password password}
                  :elasticsearch-url elasticsearch-url}
           (and has-bastion?
                (every? some? [bastion-hostname
                               bastion-user]))
           (assoc :bastion {:host        bastion-hostname
                            :user        bastion-user
                            :port        bastion-port 
                            :private-key private-key}))}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials elasticsearch-url bastion]} source
            {:keys [host user port private-key]} bastion
            has-bastion? (every? some? [host user])]
        (merge
         (select-keys credentials [:user :password])
         {:name              name
          :description       description
          :elasticsearch-url elasticsearch-url
          :bastion-hostname  host
          :bastion-user      user
          :bastion-port      port
          :private-key       private-key
          :has-bastion?      has-bastion?})))

    :validate (partial form-component/validate-form ::elasticsearch-form)

    :id :elasticsearch-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Elasticsearch URL"
              :name       :elasticsearch-url
              :required   true
              :value      ""}
             {:block-type :input
              :label      "User"
              :name       :user
              :value      ""}
             {:block-type :input
              :label      "Password"
              :name       :password
              :type       :password
              :value      ""}

             {:block-type :checkbox
              :label      "Requires tunneling"
              :name       :has-bastion?
              :type       :checkbox
              :value      false}

             {:block-type    :subtitle
              :content       "Bastion host"
              :conditions    [[:eq [:has-bastion? :value] true]]}

             {:block-type    :input
              :label         "Bastion Hostname"
              :name          :bastion-hostname
              :required      true
              :value         ""
              :default-value ""
              :conditions    [[:eq [:has-bastion? :value] true]]}

             {:block-type    :input
              :label         "Bastion User"
              :name          :bastion-user
              :value         ""
              :default-value ""
              :required      true
              :conditions    [[:eq [:has-bastion? :value] true]]}

             {:block-type    :input
              :label         "Bastion Port"
              :name          :bastion-port
              :value         ""
              :default-value ""
              :required      false
              :conditions    [[:eq [:has-bastion? :value] true]]}

             {:block-type    :file-input
              :label         "Private key file"
              :name          :private-key
              :type          :password
              :required      true
              :conditions    [[:eq [:has-bastion? :value] true]]}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status action destination-table index date-field]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:index             index
                    :date-field        date-field
                    :destination-table destination-table
                    :action            action}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:index :date-field :action :destination-table])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status}))))

    :validate (constantly nil)

    :id :elasticsearch-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :input
              :label      "Elasticsearch Index"
              :name       :index
              :required   true
              :value      ""}

             {:block-type :input
              :label      "Date Field"
              :name       :date-field
              :required   true
              :value      ""}

             {:content "Date Field is the name of the field that specifies the creation or indexing date of each document in the index"}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Append will add data incrementally according to the date field above, to the existing table."
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
